import { render } from "./StoryBoxCreate.vue?vue&type=template&id=a42480e6&scoped=true&ts=true"
import script from "./StoryBoxCreate.vue?vue&type=script&lang=ts"
export * from "./StoryBoxCreate.vue?vue&type=script&lang=ts"

import "./StoryBoxCreate.vue?vue&type=style&index=0&id=a42480e6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a42480e6"]])

export default __exports__